import { useTheme, useTranslation } from '@/app/providers';
import { cn } from '@/shared/lib/cn';

interface ThemeToggleProps {
  variant?: 'light' | 'dark';
  className?: string;
}

export function ThemeToggle({
  variant = 'light',
  className,
}: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = variant === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(
        'flex h-9 w-9 items-center justify-center rounded-lg border transition-colors',
        isDark
          ? 'border-surface-border text-surface-muted hover:bg-surface-hover hover:text-white'
          : 'text-border bg-card text-secondary hover:bg-muted hover:text-body',
        className,
      )}
      aria-label={
        theme === 'light' ? t('header.darkMode') : t('header.lightMode')
      }
      title={t('header.theme')}
    >
      {theme === 'light' ? (
        <svg
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
          />
        </svg>
      ) : (
        <svg
          className="h-4 w-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      )}
    </button>
  );
}
